import React, { ReactNode, useMemo } from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

import * as S from './sortableItem.styles'

export const SortableItem = ({
    id,
    children,
    dragHandle,
    ...props
}: {
    id: string
    children: ReactNode
    dragHandle: ReactNode
}) => {
    const { attributes, listeners, setNodeRef, transform, transition, setActivatorNodeRef } = useSortable({ id })

    const transformStyle = useMemo(() => {
        if (transform == null) {
            return null
        }

        return {
            x: transform.x,
            y: transform.y,
            scaleX: 1,
            scaleY: 1,
        }
    }, [transform])

    const style = {
        transform: CSS.Transform.toString(transformStyle),
        transition,
    }

    return (
        <S.SortableItemWrapper ref={setNodeRef} style={style} {...attributes} {...props}>
            <div ref={setActivatorNodeRef} {...listeners}>
                {dragHandle}
            </div>

            {children}
        </S.SortableItemWrapper>
    )
}
